module.exports = __webpack_public_path__ + "static/media/Leccion-4-2-Cuidando-mi-Actitud-y-Prioridades-II.c0a498cc.pdf";